module.exports = __webpack_public_path__ + "static/021.thumb-db5506878ab61b922f3a800c3a9bfc4f.jpg";